import type { AccountSummary } from '@fruitful/types';

import { requestBuilder } from '../../../../http/RequestBuilder';
import { useRefetchHolisticSummaryMutationOptions } from '../useRefetchHolisticSummaryMutationOptions';

export interface UpdateManualAccountBody {
    id: string;
    userId: string;
    name?: string;
    institutionName?: string;
    amount?: number;
    description?: string;
    interestRate?: number;
    minimumPayment?: number;
    holisticCategory?: string;
    isHidden?: boolean;
}

const useUpdateManualAccount = requestBuilder.mutation<
    AccountSummary,
    UpdateManualAccountBody
>({
    endpoint: '/api/admin/holistic/accounts/manual',
    method: 'PATCH',
});

export const useUpdateManualAccountAndRefetch = (
    membershipId: string | null,
) => {
    const refetchHolisticSummaryMutationOptions =
        useRefetchHolisticSummaryMutationOptions(membershipId);

    const { mutateAsync } = useUpdateManualAccount(
        refetchHolisticSummaryMutationOptions,
    );

    const updateManualAccountAsync = async (body: UpdateManualAccountBody) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        updateManualAccountAsync,
    };
};
